var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import './index.scss';
import MainLayout from '../../layouts/MainLayout';
import { storeCurrentMenuItemPosition } from '../../store/header/actions';
import { getAlert, resetAlertInfo } from '../../store/alert/actions';
import { alertData, isLoadAlert } from '../../store/alert/reducer';
import { deleteAlert } from '../../services/alert-service';
import * as Constant from '../../utils/Constant';
import { getPublishersByCurrentUser, notificationSimple } from '../../utils/CommonUtil';
import { LoadingWidget } from '../../components/common/loading/loading';
var AlertList = Loadable({
    loader: function () { return import('./components/list'); },
    loading: function () { return React.createElement(LoadingWidget, null); },
    render: function (loaded, props) {
        var Alerts = loaded.default;
        return React.createElement(Alerts, __assign({}, props));
    }
});
var AlertDetail = Loadable({
    loader: function () { return import('./components/detail'); },
    loading: function () { return React.createElement(LoadingWidget, null); },
    render: function (loaded, props) {
        var AlertDetailComponent = loaded.default;
        return React.createElement(AlertDetailComponent, __assign({}, props));
    }
});
var Alert = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var date = new Date();
    var alertsData = props.alertsData, isLoadingAlerts = props.isLoadingAlerts, match = props.match;
    var _a = useState([]), alertList = _a[0], setDataAlert = _a[1];
    var _b = useState("list"), viewRender = _b[0], setViewRender = _b[1];
    var _c = useState(), publishers = _c[0], setPublishers = _c[1];
    var _d = useState(), operators = _d[0], setOperators = _d[1];
    var _e = useState(null), editId = _e[0], setEditId = _e[1];
    var _isMounted = useRef(true);
    useEffect(function () {
        document.title = t("page.alert") + Constant.APP_NAME;
        props.dispatch(storeCurrentMenuItemPosition({ position: 2 }));
        getAlertData();
        return function () {
            props.dispatch(resetAlertInfo());
            _isMounted.current = false;
        };
    }, []);
    useEffect(function () {
        if (alertsData && alertsData.length) {
            setDataAlert(alertsData);
        }
    }, [alertsData]);
    useEffect(function () {
        handleRenderViewUI();
    }, [match]);
    var getAlertData = function () {
        props.dispatch(getAlert());
    };
    var getPublisher = function () {
        var publisherList = getPublishersByCurrentUser();
        setPublishers(publisherList);
    };
    var onDeleteAlert = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var result, alerts, foundIndexAlert, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteAlert(id)];
                case 1:
                    result = _a.sent();
                    if (id) {
                        alerts = alertList && alertList.length ? _.cloneDeep(alertList) : [];
                        foundIndexAlert = alerts.findIndex(function (alert) { return alert.id == id; });
                        if (foundIndexAlert > -1) {
                            alerts.splice(foundIndexAlert, 1);
                        }
                        setDataAlert(alerts);
                        notificationSimple("Delete Alert Success!", Constant.NOTIFICATION_SUCCESS);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log("Error delete alert ::");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onchangeAlertList = function (alertData, id) {
        var alerts = alertList && alertList.length ? _.cloneDeep(alertList) : [];
        if (id) {
            var foundIndexAlert = alerts.findIndex(function (alert) { return alert.id == id; });
            if (foundIndexAlert > -1) {
                alerts.splice(foundIndexAlert, 1, alertData);
            }
        }
        else {
            alerts.push(alertData);
        }
        setDataAlert(alerts);
    };
    var handleRenderViewUI = function () {
        var location = history.location;
        var viewRenderUI = "list";
        if (location.pathname.indexOf('create') !== -1) {
            viewRenderUI = "create";
        }
        else if (location.pathname.indexOf('edit') !== -1) {
            var pathname = location.pathname;
            viewRenderUI = "update";
            var listPath = pathname.split('/');
            if (listPath && listPath.length) {
                var param = listPath[2];
                if (param) {
                    param = Number(param);
                }
                setEditId(param);
            }
        }
        else if (location.pathname.indexOf('clone') !== -1) {
            var pathname = location.pathname;
            viewRenderUI = "clone";
            var listPath = pathname.split('/');
            if (listPath && listPath.length) {
                var param = listPath[2];
                if (param) {
                    param = Number(param);
                }
                setEditId(param);
            }
        }
        if (viewRenderUI == "create" || viewRenderUI == "update" || viewRenderUI == "clone") {
            getPublisher();
        }
        setViewRender(viewRenderUI);
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "layout-static" },
            React.createElement("div", { className: "static-content-wrapper" },
                React.createElement("div", { className: "static-content" },
                    React.createElement("div", { className: "page-content page-publishers" },
                        React.createElement("div", { className: "container-fluid container-alert" },
                            viewRender == "list" ?
                                React.createElement(AlertList, { data: alertList, isLoading: isLoadingAlerts, dispatch: props.dispatch, onDeleteAlert: onDeleteAlert }) :
                                null,
                            viewRender == "create" ?
                                React.createElement(AlertDetail, { publisherList: publishers, dispatch: props.dispatch, isEdit: false, isClone: false, onchangeAlertList: onchangeAlertList }) :
                                null,
                            viewRender == "update" ?
                                React.createElement(AlertDetail, { publisherList: publishers, dispatch: props.dispatch, isEdit: true, isClone: false, param: editId, onchangeAlertList: onchangeAlertList }) :
                                null,
                            viewRender == "clone" ?
                                React.createElement(AlertDetail, { publisherList: publishers, dispatch: props.dispatch, isEdit: false, isClone: true, param: editId, onchangeAlertList: onchangeAlertList }) :
                                null)))))));
};
function mapStateToProps(state) {
    return {
        alertsData: alertData(state),
        isLoadingAlerts: isLoadAlert(state)
    };
}
export default connect(mapStateToProps)(Alert);
